import { AppColors } from '@cmbg-traky-web/design-system';
import { CSSProperties } from 'react';

type FiltersToggleButtonStyles = {
  advancedButton: CSSProperties;
};

const styles: FiltersToggleButtonStyles = {
  advancedButton: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    border: `1px solid ${AppColors.VA.PRIMARY._50_}`,
    color: AppColors.VA.PRIMARY._50_,
    borderRadius: 8,
    height: '42px'
  }
};

export default styles;
